module.exports = __webpack_public_path__ + "img/Key1.71a8c96a.gif";